import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

// COMPONENTS

// MODULES
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MaterialCustomModule } from '../../material-custom.module';
import { UiModule } from '../ui/ui.module';

const angularModules = [CommonModule, MaterialCustomModule];
const lumModules = [FormsModule, ReactiveFormsModule, UiModule];

@NgModule({
  declarations: [],
  imports: [...angularModules, ...lumModules],
  exports: [],
})
export class TagModule {}
